module.exports = __webpack_public_path__ + "static/media/laji.50e79c8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/laji.mp3
// module id = uiaD
// module chunks = 208